<form
  class="login"
  [formGroup]="loginForm"
  (ngSubmit)="onLoginClick()"
>
  <mat-card class="loginCard">
    <mat-card-header class="header-login-form">
      <img
        mat-card-avatar
        class="logo"
        src="/assets/images/logo-homeleite.png"
      />

      <mat-card-title class="welcome-title">
        Bem-vindo ao Home Leite
      </mat-card-title>
    </mat-card-header>

    <section class="fields">
      <mat-form-field>
        <mat-label>Usuário</mat-label>
        <input matInput formControlName="username" type="text" required />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Senha</mat-label>
        <input matInput formControlName="password" type="password" required />
      </mat-form-field>
    </section>

    <mat-card-actions>
      <button
        #enterBtn
        type="submit"
        mat-raised-button
        class="ok-btn"
        color="primary"
        [disabled]="loginForm.invalid"
      >
        Entrar
      </button>
    </mat-card-actions>
  </mat-card>
</form>
